import React, { useLayoutEffect } from 'react'

type Props = {
  elementId: string
  toggleClass: string[]
  pageOffset: number
  children: React.ReactChild
  shouldToggleOn: boolean
}

const ScrollChecker = ({
  elementId,
  toggleClass,
  shouldToggleOn,
  pageOffset,
  children
}: Props) => {
  useLayoutEffect(() => {
    const foundRef = document.getElementById(elementId)
    if (shouldToggleOn) {
      foundRef.classList.add(toggleClass())
    } else {
      foundRef.classList.remove(toggleClass())
    }
  }, [pageOffset])

  return <>{children}</>
}

export default ScrollChecker
